import { useModal } from '@starsoft/common/hooks';
import styles from './styles.module.scss';
import { ModalsKey } from '@/enums/modalsKey';
import { Modal, ModalHeader } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import UnavailableBalanceModalContent from './Content';
import { AuthService } from '@/services/AuthService';

export default function UnavailableBalanceModal() {
  const { t } = useTranslation('common');
  const { handleContainer, isOpen, onClose } = useModal(
    ModalsKey.UnavailableBalance,
  );

  return (
    <Modal onClose={onClose} open={isOpen && AuthService.isAuthorized()}>
      <div className={styles.container} onClick={handleContainer}>
        <ModalHeader
          onClose={onClose}
          title={t('insufficient_funds')}
          smallMobilePadding
        />
        <div className={styles.container__content}>
          <UnavailableBalanceModalContent />
        </div>
      </div>
    </Modal>
  );
}
